import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Button } from '@mui/material';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 3 }}>
          <Alert
            severity="error"
            action={
              <Button color="inherit" size="small" onClick={() => window.location.reload()}>
                Recarregar
              </Button>
            }
          >
            Não foi possível renderizar o mapa. Recarregue a página ou reduza os filtros.
          </Alert>
        </Box>
      );
    }
    return this.props.children;
  }
}

MapErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MapErrorBoundary;
